import classes from './BotsCarouselItem.module.css';

export default function BotsCarouselItem({
  iconUrl,
  title,
  subtitle,
  subtitleIcon,
  description,
  isActive,
  onClick,
  className = '',
}) {
  const hasIcon = Boolean(iconUrl);
  const hasTitle = Boolean(title);
  const hasSubtitle = Boolean(subtitle) || Boolean(subtitleIcon);
  const hasDescription = Boolean(description);
  const hasInfo = hasTitle || hasSubtitle || hasDescription;

  return (
    <button
      type="button"
      className={[classes.Item, isActive ? classes.Active : '', className].filter(Boolean).join(' ')}
      onClick={onClick}
      aria-current={isActive ? 'page' : undefined}
    >
      {hasIcon ?
        <div className={classes.Icon} aria-hidden="true">
          <img src={iconUrl} alt="" className={classes.IconImg} />
        </div>
        : null}
      {hasInfo ?
        <div className={classes.Info}>
          {hasTitle ?
            <span className={classes.Title}>{title}</span>
            : null}
          {hasSubtitle ?
            <span className={classes.SubtitleRow}>
              {subtitleIcon ?
                <img src={subtitleIcon} alt="" className={classes.SubtitleIcon} />
                : null}
              {subtitle ?
                <span className={classes.Subtitle}>{subtitle}</span>
                : null}
            </span>
            : null}
          {hasDescription ?
            <span className={classes.Description}>{description}</span>
            : null}
        </div>
        : null}
    </button>
  );
}
